import Input from './Input';
import { InputModes } from './Input';

export { InputModes };
export default Input;
